<template>
    <el-row :gutter="30"  class="mw-100 manage-footer-branche" >
        
        <el-col :lg="24" :xs="24">
            <el-card>
                <el-form
                    class="text-center font-24" 
                    ref="addParentFooterBrancheRef"
                    :model="currentFooterBrancheData"
                    :rules="currentFooterBrancheDataRules"
                    label-position="top"
                >
                    <el-row :gutter="30">
                        <el-col :lg="24" :xs="24">
                            <el-form-item>
                                <el-button type="primary" @click="manageFooterBranche('addFooterBrancheRef')" class="text-cap">
                                    <font-awesome-icon :icon="['fas', 'floppy-disk']" style="width:20px" class="mr-10" />
                                    save
                                </el-button>
                            </el-form-item>
                        </el-col>
                        
                    </el-row>
                </el-form>
                <el-tabs  tab-position="left">
                    <el-tab-pane  v-for="(item, index) in currentFooterBrancheData.translates" :key="index" >
                        <template #label>
                            <span class="custom-tabs-label">
                                <span>
                                    {{$getLanguageName(item.languageID)}}
                                </span>
                            </span>
                        </template>
                        <el-form 
                            class="text-center font-24" 
                            ref="addFooterBrancheRef"
                            :model="currentFooterBrancheData"
                            :rules="currentFooterBrancheDataRules"
                            label-position="top"
                        >
                            <el-row :gutter="30">
                               
                                <el-col :lg="24" :xs="24">
                                    <el-form-item  label="title" :prop="`translates[${index}].title`" :class="$getLanguageName(item.languageID).toLowerCase() == 'عربي' ? 'text-right':''">
                                        <el-input type="text" v-model="currentFooterBrancheData.translates[index].title"></el-input>    
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="24" :xs="24">
                                    <el-form-item  label="description" :prop="`translates[${index}].description`" :class="$getLanguageName(item.languageID).toLowerCase() == 'عربي' ? 'text-right':''">
                                        <el-input type="textarea" v-model="currentFooterBrancheData.translates[index].description"></el-input>    
                                    </el-form-item>
                                </el-col>
                               
                                
                            </el-row>
                        </el-form>
                    </el-tab-pane>
                </el-tabs>
            </el-card>
        </el-col>
    </el-row>
    
</template>

<script>
export default {
    data(){
        return {
           
            isAddFooterBranche:true,
            currentFooterBranche:[],
            fileList:[],
            dialogVisible:false,
            dialogImageUrl:'',
            fileUploaded:false,

            currentFooterBrancheData:{},
            currentFooterBrancheDataRules:{
                value:{
                    required:true,
                    message:'required field',
                    trigger:'blur',
                },
                translates:this.$setTranslateRules(['title','description']),
            }
        };
    },
    computed:{
        cachedFooterBranche(){
            return JSON.parse(localStorage.getItem('adminStore'))?.website?.settings?.footer?.footerBranches.currentFooterBranche || {}
        }
    },
    mounted(){
        this.isAddFooterBranche = true;
        this.currentFooterBrancheData = this.initState()
    },
    
    methods:{
        initState(){
            return {
                translates:this.$setTranslateKeys({
                    'title':'',
                    'description':'',
                })
            }
        },
       
        async manageFooterBranche(formName){
            let successForm = [];
            for (let index = 0; index < this.$refs[formName].length; index++) {
                const element = this.$refs[formName][index];
                element.validate(async (valid) => {
                    if (!valid) {
                        this.$message({
                            message:`please fill the data in the ${this.$getOrderName(index + 1)} tab `,
                            type:'info',
                            duration:5000,
                            showClose: true,
                        });
                    }
                }).then(data =>{
                    let indexOfIndex = successForm.indexOf(index);
                    if (data){
                        successForm.push(index);
                        if (successForm.length == this.$refs['addFooterBrancheRef'].length){
                            this.manageFooterBrancheAfterValidate()
                        }
                    }else{
                        if(indexOfIndex != -1) {
                            successForm.splice(indexOfIndex,1);
                        }
                    }
                })  
            }
           
            
            
            
            
            
        },
        async manageFooterBrancheAfterValidate(){
            
            const response = await this.$store.dispatch(this.isAddFooterBranche ? 'addFooterBranche':'updateFooterBranche',this.currentFooterBrancheData);
            if (response.data.status == 1) {
                this.$notify({
                    title:String(response.status),
                    message:response.data.message,
                    type:'success',
                });
                await this.$store.dispatch('getAllFooterBranches');
                this.$router.push({
                    name:'footer-branches-list'
                })
            }
        },
        onUploadImage(file){
            if((file.size / Math.pow(1024, 2)).toFixed(2) * 1 > 5){
                this.$notify({
                    title:'File Size Exceded',
                    message:'the file uplaoded should be less than 5 MB',
                    type:'warning',
                });
                this.$refs['imageBase64'][0].clearFiles()
            }else{  
                const FR = new FileReader();
                let module = this;
                FR.addEventListener("load", function(evt) {
                    module.currentFooterBrancheData.imageBase64 = evt.target.result;
                }); 
                this.currentFooterBrancheData.imageURL =  URL.createObjectURL(file.raw);

                FR.readAsDataURL(file.raw);
            }
        },    
        handleRemoveImage(){
            this.currentFooterBrancheData.imageURL = this.isAddFooterBranche ? '' : this.cachedFooterBranche.imageURL
        }, 
       
    }
}
</script>
<style lang="scss">
    .manage-footer-branche {
        .ck-editor {
            width:100%;
        }
    }
</style>